module.exports = __webpack_public_path__ + "img/img-5.d7c62a2e.jpg";